import Head from 'next/head';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import BlogCardListing from '../../components/Blog/ArticleCardListing/ArticleCardListing';
import FooterComp from '../../components/Footer/Footer';
import HeaderComp from '../../components/Header/Header';
import Pagination from '../../components/Pagination/Pagination';
import config from '../../config/config';
import routes from '../../config/routes';
import seo from '../../config/seo';
import SetHeaders from '../../config/SetHeaders';
import httpService from '../../services/httpService';
import { useRouter } from 'next/router'

const BlogContainer = ({ history, showLoader, hideLoader }: any) => {
  const match = useRouter();
  const [state, setstate]: any = useState({
    Header: null,
    Body: null,
    Footer: null,
    response: null
  });
  const [BlogData, setBlogData]: any = useState();
  const _limit = config.blogHomePagination;

  useEffect(() => {
    showLoader();
    const getTemplate = () => {
      httpService.invokeApi({ url: config.endpoints.blog, method: 'get' }, (success: boolean, response: any) => {
        if (success) {
          setstate({
            Header: response.Header,
            Footer: response.Footer.Footer,
            Body: response.Body,
            response: response
          });
          const pageno = match.query.pageno ? +match.query.pageno : 1;
          paginate(pageno);
        }
      });
    };
    const paginate = (pageno: any) => {
      httpService.invokeApi(
        { url: config.endpoints.posts, method: 'get', params: { _limit, _start: (pageno - 1) * _limit } },
        (success: boolean, res: any) => {
          if (success) {
            setBlogData(res);
            hideLoader();
          } else {
            hideLoader();
          }
        }
      );
    };
    getTemplate();
  }, [match.query.pageno, history, _limit, hideLoader, showLoader]);

  const component = (comp: any) => {
    switch (comp.__component) {
      case 'blog.blog-card-widget':
        return <BlogCardListing cardData={BlogData.posts} column={comp.columns ? comp.columns : 3} />;
      default:
        return null;
    }
  };

  const pagination = (pageno: any) => {
    showLoader();
    httpService.invokeApi(
      { url: config.endpoints.posts, method: 'get', params: { _limit, _start: (pageno - 1) * _limit } },
      (success: boolean, res: any) => {
        if (success) {
          setBlogData(res);
          hideLoader();
        } else {
          hideLoader();
        }
      }
    );
  };

  return (
    <React.Fragment>
      {state.Body && !state.Body.Seo && (
        <Head>
          <title>{seo.blog}</title>
        </Head>
      )}
      {state.response && <SetHeaders HEADERS={state.response} />}
      {state.Header && <HeaderComp HeaderValue={state.Header} />}
      <div className="app-body p-b-5p">
        {state.Body && BlogData && (
          <React.Fragment>
            {state.Body.length > 0 &&
              state.Body.map((item: any, i: number) => {
                return <React.Fragment key={i}>{component(item)}</React.Fragment>;
              })}
            {BlogData && BlogData.page && (
              <Pagination
                currentPage={match.query.pageno ? +match.query.pageno : 1}
                history={history}
                totalRecords={BlogData.page.totalElements}
                recordsPerPage={parseInt(BlogData.page._limit)}
                Change={pageno => {
                  pagination(pageno);
                }}
                path={`${routes.blogHome}`}
              />
            )}
          </React.Fragment>
        )}
      </div>
      {state.Footer && <FooterComp data={state.Footer} />}
    </React.Fragment>
  );
};

const mapState = (state: any) => {
  return {};
};

const mapDispatch = (dispatch: any) => {
  return {
    showLoader: () => dispatch({ type: 'LOADER_SHOW', isLoadingPage: true }),
    hideLoader: () => dispatch({ type: 'LOADER_HIDE' })
  };
};

export default connect(
  mapState,
  mapDispatch
)(BlogContainer);
